export default "<p>dinein-food works!</p>\r\n"